import {
  reffPartner,
  pricingPlan,
  editEmailTemp,
  createPricingPlan,
  ausText1,
  nzText2,
  UserManagment,
  createPromocode,
  smsTemplate,
  monthlyLending,
  ownerTab,
  customerTab,
  createAccPage,
  roleMange,
  overdueRE,
  InvoiceAllDetails,
  emailTemplate,
  fundedInvoicesData,
  monthlyCommison,
  bankDetls
} from "../locales/en";
import { PROCESSING } from "./constants/appConstants";

export const getOrgTypeOptions = () => {
  const { orgtypeoptions } = createPricingPlan || {};

  const values = [
    "Partnership",
    "Accounting Practice",
    "Trust",
    "Sole Trader",
    "Company",
    "Limited Partnership"
  ];

  const options = values.map((value, index) => ({
    value,
    label: orgtypeoptions?.[`item${index + 1}`] || value
  }));

  return [
    {
      value: "NA",
      label: createPricingPlan?.industryTypeOptions.item1
    },
    ...options
  ];
};

export const getCountryOptions = () => {
  const { filter } = monthlyLending || {};

  const countries = [
    { code: "AU", key: "au" },
    { code: "NZ", key: "nz" }
  ];

  const options = countries.map(({ code, key }) => ({
    value: code,
    label: filter?.[key] || code
  }));

  return [
    {
      value: "NA",
      label: createPricingPlan?.industryTypeOptions.item1
    },
    ...options
  ];
};

export const getGenderOptions = () => {
  const { ownerDetails } = ownerTab || {};

  const genderValues = [
    { value: "Male", label: ownerTab?.ownerDetails.male },
    { value: "Female", label: ownerTab?.ownerDetails.female }
  ];

  const options = genderValues.map(({ value, key }) => ({
    value,
    label: ownerDetails?.[key] || value
  }));

  return options;
};

export const getMonthOptions = () => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];

  return months.map((month, index) => ({
    value: index,
    label: month,
    index
  }));
};

export const getReferralMonthOptions = () => {
  const { mailSendModal } = reffPartner?.partnermanage || {};

  return [
    { value: "", label: monthlyCommison.filter.selectCountry },
    { value: "2024-06", label: mailSendModal?.date1 },
    { value: "2024-05", label: mailSendModal?.date2 },
    { value: "2024-04", label: mailSendModal?.date3 },
    { value: "2024-03", label: mailSendModal?.date4 }
  ];
};

export const getReferralDiscountOptions = () => {
  const { mailSendModal } = reffPartner?.partnermanage || {};

  return [
    {
      value: "NA",
      label: "Select Discount"
    },
    {
      value: mailSendModal?.discountLi1,
      label: mailSendModal?.discountLi1
    },
    {
      value: mailSendModal?.discountLi2,
      label: mailSendModal?.discountLi2
    },
    {
      value: mailSendModal?.discountLi3,
      label: mailSendModal?.discountLi3
    }
  ];
};

export const getReferralClientTypeOptions = () => {
  const { mailSendModal } = reffPartner?.partnermanage || {};

  return [
    {
      value: "NA",
      label: "Select Client Type"
    },
    {
      value: mailSendModal?.showClientTypeLi1,
      label: mailSendModal?.showClientTypeLi1
    },
    {
      value: mailSendModal?.showClientTypeLi2,
      label: mailSendModal?.showClientTypeLi2
    },
    {
      value: mailSendModal?.showClientTypeLi3,
      label: mailSendModal?.showClientTypeLi3
    }
  ];
};

export const getPricingPlanTypeOptions = () => {
  const { pricingtable } = pricingPlan || {};

  return [
    {
      value: "",
      label: pricingPlan?.pricingtable.all
    },
    {
      value: "Standard",
      label: pricingtable?.standard
    },
    {
      value: "Variable",
      label: pricingtable?.riskVariable
    }
  ];
};

export const getEmailElementOptions = () => {
  const { selectElementLi } = editEmailTemp || {};

  return [
    { value: "", label: editEmailTemp.selectElement },
    { value: "paragraph", label: selectElementLi?.item1 },
    { value: "button", label: selectElementLi?.item2 },
    { value: "link", label: selectElementLi?.item3 },
    { value: "hrLine", label: selectElementLi?.item4 }
  ];
};

export const getButtonTypeOptions = () => {
  const { propertyOptions } = createPricingPlan || {};

  return [
    { value: "No", label: propertyOptions?.item2 },
    { value: "Yes", label: propertyOptions?.item1 }
  ];
};

export const getPermissionTypeOptions = () => {
  return [
    { value: "All", label: InvoiceAllDetails?.all },
    { value: "Custom", label: InvoiceAllDetails?.Custom }
  ];
};

export const getTriggerOverdueOptions = () => [
  { value: "Pending", label: overdueRE?.rowItems?.item4 },
  { value: "Approved", label: overdueRE?.rowItems?.item5 },
  { value: "Funded", label: overdueRE?.rowItems?.item2 },
  { value: "In Default", label: overdueRE?.rowItems?.item9 },
  { value: "Overdue", label: overdueRE?.rowItems?.item17 },
  { value: "Completed", label: overdueRE?.rowItems?.item1 },
  { value: "Unrecoverable", label: overdueRE?.rowItems?.item8 },
  { value: "Not Approved", label: overdueRE?.rowItems?.item7 },
  { value: "Cust Not Require", label: overdueRE?.rowItems?.item11 },
  { value: "Processing", label: overdueRE?.rowItems?.item3 }
];

export const getTriggerOverdue = () => [
  { value: "Pending", label: overdueRE?.rowItems?.item4 },
  { value: "Approved", label: overdueRE?.rowItems?.item5 },
  { value: "Outstanding", label: overdueRE?.rowItems?.item6 },
  { value: "Funded", label: overdueRE?.rowItems?.item2 },
  { value: "Not Approved", label: overdueRE?.rowItems?.item7 },
  { value: "Unrecoverable", label: overdueRE?.rowItems?.item8 },
  { value: "In Default", label: overdueRE?.rowItems?.item9 },
  { value: "Completed", label: overdueRE?.rowItems?.item1 },
  { value: "No AML", label: overdueRE?.rowItems?.item10 },
  { value: "Overdue", label: overdueRE?.rowItems?.item17 },
  { value: "Cust Not Require", label: overdueRE?.rowItems?.item11 }
];

export const getAccountingSoftwareOptions = () => {
  const { accSoftwareoptions } = createPricingPlan || {};

  return [
    {
      value: "NA",
      label: createPricingPlan?.industryTypeOptions.item1
    },
    { value: "Xero", label: accSoftwareoptions?.item1 },
    { value: "QuickBooks", label: accSoftwareoptions?.item2 },
    { value: "MYOB", label: accSoftwareoptions?.item3 },
    { value: "Reckon", label: accSoftwareoptions?.item4 },
    { value: "Manual Entry", label: accSoftwareoptions?.item5 }
  ];
};

export const getApplyIdMandatoryOptions = () => {
  const { ownerTab } = UserManagment || {};
  const status =
    ownerTab?.identificationSection?.isApplyIdMandatoryStatus || {};

  return [
    { value: "true", label: status?.true },
    { value: "false", label: status?.false }
  ];
};

export const getTwoFactorOptions = () => [
  { value: "false", label: customerTab.systemControl.disable },
  { value: "true", label: customerTab.systemControl.enable }
];

export const getActiveStatusOptions = () => [
  { value: "true", label: createAccPage.active },
  { value: "false", label: createAccPage.inactive }
];

export const getPermissionAccessOptions = () => [
  { value: "true", label: roleMange.table.fullAccess },
  { value: "false", label: roleMange.table.limitedAccess }
];

export const getSmsCountryOptions = () => [
  { value: "", label: monthlyCommison.filter.selectCountry },
  { value: "aus", label: ausText1 },
  { value: "nz", label: nzText2 }
];

export const getClientStatusOptions = () => [
  { value: "1", label: overdueRE.rowItems.item4 },
  { value: "2", label: overdueRE.rowItems.item5 },
  { value: "3", label: overdueRE.rowItems.item7 },
  { value: "7", label: overdueRE.rowItems.item12 },
  { value: "9", label: overdueRE.rowItems.item13 },
  { value: "12", label: overdueRE.rowItems.item16 },
  { value: "13", label: overdueRE.rowItems.item18 }
];

export const getSmsSenderOptions = () => [
  {
    value: "FundTap",
    label: smsTemplate.sendModal.fundtap
  },
  {
    value: "6421804033",
    label: smsTemplate.sendModal.number
  }
];

export const getIdTypeOptions = () => [
  {
    value: "",
    label: "select"
  },
  {
    value: "Passport",
    label: ownerTab?.identification.manualUploadTable.passport
  },
  {
    value: "Driving License",
    label: ownerTab?.identification.manualUploadTable.drivingLicense
  },
  {
    value: "Other",
    label: createPricingPlan?.industryTypeOptions.item8
  }
];

export const getAustralianStateOptions = () => [
  {
    value: "",
    label: "Select State"
  },
  {
    value: "ACT",
    label: ownerTab?.identification.manualUploadTable.selectStateLi.li1
  },
  {
    value: "NSW",
    label: ownerTab?.identification.manualUploadTable.selectStateLi.li2
  },
  {
    value: "NT",
    label: ownerTab?.identification.manualUploadTable.selectStateLi.li3
  },
  {
    value: "QLD",
    label: ownerTab?.identification.manualUploadTable.selectStateLi.li4
  },
  {
    value: "SA",
    label: ownerTab?.identification.manualUploadTable.selectStateLi.li5
  },
  {
    value: "TAS",
    label: ownerTab?.identification.manualUploadTable.selectStateLi.li6
  },
  {
    value: "VIC",
    label: ownerTab?.identification.manualUploadTable.selectStateLi.li7
  },
  {
    value: "WA",
    label: ownerTab?.identification.manualUploadTable.selectStateLi.li8
  }
];

export const getInvoiceOptions = () => [
  { value: "LOWEST_VALUE", label: createPromocode?.applyDiscountToOpt1 },
  { value: "ALL", label: createPromocode?.applyDiscountToOpt2 },
  { value: "HIGHEST_VALUE", label: createPromocode?.applyDiscountToOpt3 }
];

export const getSingleUseOptions = () => [
  { value: "Yes", label: createPricingPlan.propertyOptions.item1 },
  { value: "No", label: createPricingPlan.propertyOptions.item2 }
];

export const getActiveStatus = () => [
  { value: "Active", label: createAccPage?.active },
  { value: "Inactive", label: createAccPage?.inactive }
];

export const getAllCountryOptions = () => [
  { id: 1, label: "All", value: "" },
  { id: 2, label: "NZ", value: "NZ" },
  { id: 3, label: "AU", value: "AU" }
];

export const getViewTypeOptions = () => [
  { id: 1, label: "Month", value: "Month" },
  { id: 2, label: "Quarter", value: "Quarter" },
  { id: 3, label: "Year", value: "Year" }
];

export const getinvoiceOptions = () => [
  { value: "all_oustanding_invoices", label: "All Outstanding Invoices" },
  { value: "processing", label: "Processing Invoices" },
  { value: "over_due", label: "Overdue Invoices" },
  { value: "all_invoices", label: "All Invoices" },
  { value: "quote_ids", label: "Selected" },
  { value: "time_period", label: "Time Period" }
];

export const getEmailTypeOptions = () => [
  { value: "", label: emailTemplate.emailOptions1 },
  { value: "Customer Email Template", label: emailTemplate.emailOptions2 },
  { value: "Referral Email Template", label: emailTemplate.emailOptions3 },
  { value: "Admin Email Template", label: emailTemplate.emailOptions4 }
];

export const getInvoiceTypeOptions = () => [
  { value: "", label: fundedInvoicesData?.funded?.filter?.all },
  {
    value: PROCESSING,
    label: fundedInvoicesData?.funded?.filter?.dueInvoice
  },
  {
    value: "PENDING",
    label: fundedInvoicesData?.funded?.filter?.pendingInvoice
  }
];

export const getcustomerFilter = () => [
  {
    id: 1,
    label: "All",
    value: ""
  },
  {
    id: 2,
    label: "Funds Outstanding",
    value: "funds_outstanding"
  },
  {
    id: 3,
    label: "Approved",
    value: "approved"
  },
  {
    id: 4,
    label: "Transacted",
    value: "transacted"
  }
];

export const getSelectDevice = () => [
  {
    id: 1,
    label: "All"
  },
  {
    id: 2,
    label: "Mobile",
    value: "Mobile"
  },
  {
    id: 3,
    label: "Desktop",
    value: "Desktop"
  }
];

export const getReferral = () => [
  {
    id: 0,
    label: "All",
    value: ""
  },
  {
    id: 1,
    label: "Referral",
    value: "referral"
  },
  {
    id: 2,
    label: "Other",
    value: "other"
  }
];

export const getAllViewType = () => [
  {
    id: 1,
    label: "Month",
    value: "month"
  },
  {
    id: 2,
    label: "Quarter",
    value: "quarter"
  },
  {
    id: 3,
    label: "Year",
    value: "year"
  },
  {
    id: 4,
    label: "Week",
    value: "week"
  }
];

export const getDataTypes = [
  {
    id: 0,
    label: "Lending",
    value: "lending"
  },
  {
    id: 1,
    label: "Customers",
    value: "customers"
  }
];

export const getPeriods = [
  {
    id: 1,
    label: "1",
    value: "1"
  },
  {
    id: 2,
    label: "2",
    value: "2"
  },
  {
    id: 3,
    label: "3",
    value: "3"
  },
  {
    id: 4,
    label: "4",
    value: "4"
  },
  {
    id: 5,
    label: "5",
    value: "5"
  },
  {
    id: 6,
    label: "6",
    value: "6"
  },
  {
    id: 7,
    label: "7",
    value: "7"
  },
  {
    id: 8,
    label: "8",
    value: "8"
  },
  {
    id: 9,
    label: "9",
    value: "9"
  },
  {
    id: 10,
    label: "10",
    value: "10"
  },
  {
    id: 11,
    label: "11",
    value: "11"
  },
  {
    id: 12,
    label: "12",
    value: "12"
  }
];

export const getYears_periods = [
  {
    id: 1,
    label: "All",
    value: ""
  }
];

export const companyEntityOptions = () => [
  {
    value: "",
    label: "Select"
  },
  {
    value: "Sole Trader",
    label: createPricingPlan?.orgtypeoptions.item4
  },
  {
    value: "Partnership",
    label: createPricingPlan?.orgtypeoptions.item1
  },
  {
    value: "Trust",
    label: createPricingPlan?.orgtypeoptions.item3
  },
  {
    value: "Company",
    label: createPricingPlan?.orgtypeoptions.item5
  },
  {
    value: "Other",
    label: createPricingPlan?.industryTypeOptions.item8
  }
];

export const getFindFromOptions = () => [
  { value: "", label: bankDetls?.plsSelect },
  { value: "google", label: bankDetls?.google },
  { value: "facebook", label: bankDetls?.facebook },
  { value: "accountant_advisor", label: bankDetls?.accAdvisor },
  { value: "from_a_fundtap_client", label: bankDetls?.fromFundtap },
  { value: "fromOther", label: bankDetls?.otherPlsSpcfy }
];

export const getOwnPropertyOptions = () => [
  {
    label: "Select",
    value: ""
  },
  {
    label: "Yes",
    value: "Yes"
  },
  {
    label: "No",
    value: "No"
  },
  {
    label: "No - but I own other property",
    value: "No-but I own other Property"
  }
];

export const allowedLabels = [
  {
    label: "Bookkeeper",
    value: "Bookkeeper"
  },
  {
    label: "Accountant",
    value: "Accountant"
  },
  {
    label: "Finance Brokers",
    value: "Broker"
  },
  {
    label: "Platform",
    value: "Platform"
  },
  {
    label: "Referrers",
    value: "Other"
  }
];

export const getIndustrylist = [
  {
    id: 1,
    name: "All",
    value: ""
  },
  {
    id: 2,
    name: "Trades/Construction",
    value: 1
  },
  {
    id: 3,
    name: "Consultants",
    value: 2
  },
  {
    id: 4,
    name: "Recruitment",
    value: 3
  },
  {
    id: 5,
    name: "Distributors/Wholesalers",
    value: 4
  },
  {
    id: 6,
    name: "B2B Service Provider",
    value: 5
  },
  {
    id: 7,
    name: "Other",
    value: 6
  }
];

export const getCommercialCredit = [
  {
    id: 1,
    name: "All",
    value: ""
  },
  {
    id: 2,
    name: "Yes",
    value: "yes"
  },
  {
    id: 3,
    name: "No",
    value: "no"
  }
];

const USER_PROPERTY_TYPE = [
  { name: "All", value: "" },
  { name: "Yes", value: "yes" },
  { name: "No", value: "no" },
  {
    name: "No - but I own other property",
    value: "no-but I own other property"
  }
];

export const getPopertyOwnerShp = USER_PROPERTY_TYPE.map((item, index) => ({
  id: index + 1,
  ...item
}));

const USER_ORG_TYPES = [
  "All",
  "Company",
  "Sole Trader",
  "Partnership",
  "Limited Partnership",
  "Trust",
  "Accounting Practice"
];

export const getOrgType = USER_ORG_TYPES.map((label, index) => ({
  id: index + 1,
  name: label,
  value: label === "All" ? "" : label
}));

const SOFTWARE_NAME = [
  { name: "All", value: "" },
  { name: "Xero", value: "xero" },
  { name: "QuickBooks", value: "quickbooks" },
  { name: "Myob", value: "myob" },
  { name: "Reckon", value: "reckon" },
  { name: "Manual Entry", value: "manual entry" },
  { name: "Disconnected", value: "disconnected" },
  { name: "None", value: "none" }
];
export const getAccSoftWare = SOFTWARE_NAME.map((item, index) => ({
  id: index + 1,
  ...item
}));

export const status_short_dashboard = [
  {
    name: "All",
    value: ""
  },
  {
    name: "Pending",
    value: 1
  },
  {
    name: "Approved",
    value: 2
  },
  {
    name: "Funded",
    value: 4
  },
  {
    name: "Processing",
    value: 7
  },
  {
    name: "Overdue",
    value: 11
  },
  {
    name: "In Default",
    value: 8
  },
  {
    name: "Completed",
    value: 9
  },
  {
    name: "Unrecoverable",
    value: 6
  },
  {
    name: "Not Approved",
    value: 5
  },
  {
    name: "Cust Not Require",
    value: 12
  },
  {
    name: "In Review",
    value: 14
  },
  {
    name: "Clearing",
    value: 15
  }
];

export const editTextAlign = [
  {
    value: "left",
    label: editEmailTemp.textAlignmentLi.item1
  },
  {
    value: "center",
    label: editEmailTemp.textAlignmentLi.item2
  },
  {
    value: "right",
    label: editEmailTemp.textAlignmentLi.item3
  }
];

export const PERIOD_BY_VIEWTYPE = {
  Month: 12,
  Quarter: 4,
  Year: 1
};

export const years_periods = [
  {
    id: 1,
    name: "1",
    value: "1"
  },
  {
    id: 2,
    name: "2",
    value: "2"
  },
  {
    id: 3,
    name: "3",
    value: "3"
  },
  {
    id: 4,
    name: "4",
    value: "4"
  },
  {
    id: 5,
    name: "5",
    value: "5"
  },
  {
    id: 6,
    name: "6",
    value: "6"
  },
  {
    id: 7,
    name: "7",
    value: "7"
  },
  {
    id: 8,
    name: "8",
    value: "8"
  }
];

export const querter_periods = [
  {
    id: 2,
    name: "2",
    value: "2"
  },
  {
    id: 4,
    name: "4",
    value: "4"
  },
  {
    id: 8,
    name: "8",
    value: "8"
  },
  {
    id: 12,
    name: "12",
    value: "12"
  },
  {
    id: 16,
    name: "16",
    value: "16"
  },
  {
    id: 20,
    name: "20",
    value: "20"
  }
];

export const DOLLAR_FIELDS = [
  "creditLimit",
  "totalCompleted",
  "fundedInvoicesAmount",
  "totalFee"
];

const MONTHLY_TIME_PERIOD_VALUES = ["6", "12", "24", "36", "48", "60"].map(
  (v) => [v, v]
);
export const monthly_time_period = MONTHLY_TIME_PERIOD_VALUES.map(
  ([time, value], index) => ({
    id: index + 1,
    time,
    value
  })
);

export const PAYMENT_STATUS_MAPPING = {
  "DISHONOURS - Direct Debit": "DISHONOURS_DIRECT_DEBIT",
  "COMPLETED - Direct Debit": "COMPLETED_DIRECT_DEBIT",
  "SUBMITTED - Direct Debit": "SUBMITTED_DIRECT_DEBIT",
  "PAID OUT - Direct Debit": "PAID_OUT_DIRECT_DEBIT",
  "COMPLETED - Manual Payments": "COMPLETED_MANUAL_PAYMENTS",
  "PART PAID - Manual Payments": "PART_PAID_MANUAL_PAYMENTS"
};

export const INVOICE_TAB_STATUSES_TO_SHOW = [
  { label: "Pending", value: "Pending", quoteStatusId: 1 },
  { label: "Approved", value: "Approved", quoteStatusId: 2 },
  { label: "Funded", value: "Funded", quoteStatusId: 4 },
  { label: "Processing", value: PROCESSING, quoteStatusId: 7 },
  { label: "Clearing", value: "Clearing", quoteStatusId: 15 },
  { label: "Overdue", value: "Overdue", quoteStatusId: 11 }
];
